import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { GOOGLE_CALENDAR_CALLBACK } from '../config/Config';

const GoogleCalendarCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing Google Calendar authorization...');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
          setStatus('error');
          setMessage(`Authorization failed: ${error}`);
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
          return;
        }

        if (!code) {
          setStatus('error');
          setMessage('No authorization code received');
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
          return;
        }

        // Send the authorization code to our backend
        const response = await api.post(GOOGLE_CALENDAR_CALLBACK, {
          code: code
        });

        if (response.data.synced) {
          setStatus('success');
          setMessage('Google Calendar connected successfully!');
          setTimeout(() => {
            navigate('/dashboard');
          }, 2000);
        } else {
          setStatus('error');
          setMessage('Failed to connect Google Calendar');
          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
        }

      } catch (error) {
        console.error('Google Calendar callback error:', error);
        setStatus('error');
        setMessage('Failed to process Google Calendar authorization');
        setTimeout(() => {
          navigate('/dashboard');
        }, 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default',
        gap: 3,
        p: 3
      }}
    >
      {status === 'processing' && (
        <>
          <CircularProgress size={60} thickness={4} />
          <Typography variant="h6" color="text.secondary">
            {message}
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <Alert severity="success" sx={{ width: '100%', maxWidth: 400 }}>
            <Typography variant="h6">Success!</Typography>
            <Typography>{message}</Typography>
          </Alert>
        </>
      )}

      {status === 'error' && (
        <>
          <Alert severity="error" sx={{ width: '100%', maxWidth: 400 }}>
            <Typography variant="h6">Error</Typography>
            <Typography>{message}</Typography>
          </Alert>
        </>
      )}
    </Box>
  );
};

export default GoogleCalendarCallback; 